import { postWebViewMessage } from "../common/helpers/messageHelper"


export const postMessageTypes = {
    openLinkListCustomerForm: 1,
    selectLinkListGroupCodes: 2,
    selectDepartmentList: 3,
    selectDivisionList: 4,
    selectCustomerListByFilter: 5,
    openFormByParameter: 6,
    getDefaultInformation: 7,
    getCustomerInfo: 8,
    getLicenceKey: 9,
    getClientInfo: 10,
    exitApp: 11,
    integration: 12,
    singleIntegration :13,
    openErpBankList: 14,
    selectCurrencyList: 15,
    selectErpParameterList : 16,
    selectContractList : 17,
    runSqlFromParameter: 18
}
export const customerSelectFrom = {
    fromSheetPayment: 1,
    fromLinkList: 2,
    fromOrderReport: 3,
    fromFreePayment: 4,
    fromErpIntegration: 5,
    fromVpInformations: 6,
}
export const departmentSelectFrom = {
    fromSheetPayment: 1,
    fromLinkList: 2,
    fromOrderReport: 3,
    fromFreePayment: 4,
}
export const integrationRequestTypes = {
    creditCard: 1,
}
export const openFormOperationType = {
    new : 0,
    edit: 1,
    view: 2,
    locate: 3,
    check: 4,
}

export function openFormByParameter(messageBody){

    postWebViewMessage(JSON.stringify(messageBody));
}

export const SqlGeneratorTypes={
    batchLinkCustomerListSql: 1,
    selectGroupCodesSql: 2,
    selectErpParameterListSql: 3,

}
 